(function () {
  if (window.__oluCustomWbPopupInit) return;
  window.__oluCustomWbPopupInit = true;

  var ONCE_PREFIX = 'olu:custom-wb-once:';
  var CLOSED_PREFIX = 'olu:custom-wb-closed:';
  var WINNER_KEY = 'olu:custom-wb-winner';
  var X_SOURCE = 'x';
  var X_MEDIUM = 'cpc';

  function designMode() {
    return Boolean(window.Shopify && Shopify.designMode);
  }

  function normalize(value) {
    return (value || '').trim().toLowerCase();
  }

  function getParam(name) {
    try {
      return normalize(new URLSearchParams(window.location.search).get(name));
    } catch (error) {
      return '';
    }
  }

  function storageGet(storage, key) {
    try {
      return storage.getItem(key);
    } catch (error) {
      return null;
    }
  }

  function storageSet(storage, key, value) {
    try {
      storage.setItem(key, value);
    } catch (error) {
      /* private mode */
    }
  }

  function isUtm(el) {
    return el.getAttribute('data-match-utm') === 'true';
  }

  function matchesXAd(el) {
    if (getParam('utm_source') !== X_SOURCE) return false;
    if (getParam('utm_medium') !== X_MEDIUM) return false;
    var campaign = normalize(el.getAttribute('data-utm-campaign'));
    if (campaign && getParam('utm_campaign') !== campaign) return false;
    return true;
  }

  function withinDate(el) {
    var now = new Date();
    var start = new Date(el.getAttribute('data-start-date'));
    var end = new Date(el.getAttribute('data-end-date'));
    if (isNaN(start.getTime()) || isNaN(end.getTime())) return false;
    return now >= start && now <= end;
  }

  function isHomePage() {
    return window.location.pathname === '/' || window.location.pathname === '';
  }

  function passesBaseFilters(el) {
    var hideForAccount = el.getAttribute('data-hide-for-account-holders') === 'true';
    var loggedIn = el.getAttribute('data-logged-in') === 'true';
    if (hideForAccount && loggedIn) return false;

    var showOnlyOnIndex = el.getAttribute('data-show-only-on-index') === 'true';
    if (showOnlyOnIndex && !isHomePage()) return false;

    if (!withinDate(el)) return false;

    var sectionId = el.getAttribute('data-section-id');
    if (isUtm(el) && el.getAttribute('data-show-only-once') === 'true' && storageGet(localStorage, ONCE_PREFIX + sectionId) === '1') {
      return false;
    }

    if (el.getAttribute('data-hide-on-session-close') === 'true' && storageGet(sessionStorage, CLOSED_PREFIX + sectionId) === '1') {
      return false;
    }

    return true;
  }

  function preferCampaign(timers) {
    var withCampaign = timers.filter(function (el) {
      return Boolean(normalize(el.getAttribute('data-utm-campaign')));
    });
    return withCampaign[0] || timers[0] || null;
  }

  function pickUtmWinner(timers) {
    if (designMode()) {
      return timers.filter(withinDate)[0] || null;
    }

    var urlEligible = timers.filter(function (el) {
      return passesBaseFilters(el) && matchesXAd(el);
    });

    if (urlEligible.length) {
      var winner = preferCampaign(urlEligible);
      if (winner && winner.getAttribute('data-hide-on-session-close') === 'true') {
        storageSet(sessionStorage, WINNER_KEY, winner.getAttribute('data-section-id'));
      }
      return winner;
    }

    var winnerId = storageGet(sessionStorage, WINNER_KEY);
    if (!winnerId) return null;

    return timers.filter(function (el) {
      return el.getAttribute('data-section-id') === winnerId
        && el.getAttribute('data-hide-on-session-close') === 'true'
        && passesBaseFilters(el);
    })[0] || null;
  }

  function hideTimer(timer) {
    timer.style.display = 'none';
    var panel = timer.querySelector('.custom-wb-panel');
    if (panel) panel.classList.remove('is-visible');
  }

  function showTimer(timer) {
    timer.style.display = 'block';
    var panel = timer.querySelector('.custom-wb-panel');
    if (panel) {
      window.requestAnimationFrame(function () {
        panel.classList.add('is-visible');
      });
    }

    if (isUtm(timer) && timer.getAttribute('data-show-only-once') === 'true') {
      storageSet(localStorage, ONCE_PREFIX + timer.getAttribute('data-section-id'), '1');
    }
  }

  function setupCloseButtons(timers) {
    timers.forEach(function (timer) {
      var button = timer.querySelector('.pop-in__close-button');
      if (!button || button.getAttribute('data-custom-wb-bound') === 'true') return;
      button.setAttribute('data-custom-wb-bound', 'true');
      button.addEventListener('click', function () {
        hideTimer(timer);
        if (timer.getAttribute('data-hide-on-session-close') === 'true') {
          storageSet(sessionStorage, CLOSED_PREFIX + timer.getAttribute('data-section-id'), '1');
        }
      });
    });
  }

  function getTimers() {
    return Array.prototype.slice.call(document.querySelectorAll('.view_timer'));
  }

  function updateAllPopups() {
    var timers = getTimers();
    setupCloseButtons(timers);

    var utmTimers = timers.filter(isUtm);
    var normalTimers = timers.filter(function (el) {
      return !isUtm(el);
    });

    normalTimers.forEach(function (timer) {
      if (passesBaseFilters(timer)) {
        timer.style.display = 'block';
      } else {
        hideTimer(timer);
      }
    });

    utmTimers.forEach(hideTimer);

    var winner = pickUtmWinner(utmTimers);
    if (!winner) return;

    if (designMode()) {
      showTimer(winner);
      return;
    }

    var delay = parseInt(winner.getAttribute('data-apparition-delay') || '0', 10) * 1000;
    var winnerId = winner.getAttribute('data-section-id');
    window.setTimeout(function () {
      var current = pickUtmWinner(getTimers().filter(isUtm));
      if (!current || current.getAttribute('data-section-id') !== winnerId) return;
      showTimer(current);
    }, delay);
  }

  function init() {
    updateAllPopups();

    if (designMode()) {
      document.addEventListener('shopify:section:load', updateAllPopups);
      document.addEventListener('shopify:section:select', function (event) {
        var timer = event.target.querySelector('.view_timer');
        if (!timer) return;
        getTimers().forEach(hideTimer);
        showTimer(timer);
      });
      window.setInterval(updateAllPopups, 1000);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
